import {AppLanguage} from './app-language.model';

export enum OrderProgress {
  Created = 0,
  Started = 1,
  Trial = 3,
  Finished = 4,
  Returned = 5,
}

export interface OrderProgressStyle {
  backgroundColor: string;
  color: string;
}

export const ORDER_PROGRESS_LABELS: Record<AppLanguage, Record<OrderProgress, string>> = {
  mk: {
    [OrderProgress.Created]: 'Креирано',
    [OrderProgress.Started]: 'Почнато',
    [OrderProgress.Trial]: 'На проба',
    [OrderProgress.Finished]: 'Завршено',
    [OrderProgress.Returned]: 'Вратено'
  },
  en: {
    [OrderProgress.Created]: 'Created',
    [OrderProgress.Started]: 'Started',
    [OrderProgress.Trial]: 'Trial',
    [OrderProgress.Finished]: 'Finished',
    [OrderProgress.Returned]: 'Returned'
  }
};

export function getOrderProgressLabel(
  progress: OrderProgress,
  language: AppLanguage = 'mk'
): string {
  return ORDER_PROGRESS_LABELS[language]?.[progress] ?? OrderProgress[progress] ?? '';
}

export function getOrderProgressStyle(progress: OrderProgress): OrderProgressStyle {
  switch (progress) {
    case OrderProgress.Created:
      return { backgroundColor: 'rgba(108, 117, 125, 0.15)', color: '#6c757d' };
    case OrderProgress.Started:
      return { backgroundColor: 'rgba(13, 110, 253, 0.15)', color: '#0d6efd' };
    case OrderProgress.Trial:
      return { backgroundColor: 'rgba(255, 193, 7, 0.2)', color: '#ffc107' };
    case OrderProgress.Finished:
      return { backgroundColor: 'rgba(25, 135, 84, 0.15)', color: '#198754' };
    case OrderProgress.Returned:
      return { backgroundColor: 'rgba(220, 53, 69, 0.15)', color: '#dc3545' };
    default:
      return { backgroundColor: 'rgba(108, 117, 125, 0.1)', color: '#6c757d' };
  }
}
